import type { Fragment } from "../types.js";
import { getSafeZone, type PlatformId } from "../format.js";
import type { FormatId } from "../format.js";

/**
 * Debug overlay drawing red hatched bars on the unsafe zones and a green
 * outline around the safe zone. Mirrors `SafeZoneOverlay.tsx`.
 */
export function safeZoneOverlay(opts: {
  id: string;
  enabled?: boolean;
  format: FormatId;
  platform?: PlatformId;
}): Fragment {
  const { id, enabled = false, format, platform = "general" } = opts;
  if (!enabled) return { html: "" };
  const sz = getSafeZone(format, platform);

  const stripe =
    "background:repeating-linear-gradient(45deg, rgba(220,38,38,0.18) 0 12px, rgba(220,38,38,0.32) 12px 24px);border:1px dashed rgba(220,38,38,0.85);pointer-events:none;";
  const labelStyle =
    "position:absolute;font-size:18px;font-weight:800;letter-spacing:1px;color:#fff;background:rgba(220,38,38,0.85);padding:4px 10px;border-radius:6px;text-transform:uppercase;box-shadow:0 4px 12px rgba(0,0,0,0.5);";

  const html = `<div id="${id}" class="safe-zone-overlay" style="position:absolute;inset:0;pointer-events:none;z-index:10000;">
  <div style="position:absolute;top:0;left:0;right:0;height:${sz.top}px;${stripe}">
    <span style="${labelStyle}top:8px;left:12px;">TOP ${sz.top}px · ${platform}</span>
  </div>
  <div style="position:absolute;bottom:0;left:0;right:0;height:${sz.bottom}px;${stripe}">
    <span style="${labelStyle}bottom:8px;left:12px;">BOTTOM ${sz.bottom}px · ${platform}</span>
  </div>
  <div style="position:absolute;top:${sz.top}px;bottom:${sz.bottom}px;left:0;width:${sz.left}px;${stripe}"></div>
  <div style="position:absolute;top:${sz.top}px;bottom:${sz.bottom}px;right:0;width:${sz.right}px;${stripe}"></div>
  <div style="position:absolute;top:${sz.top}px;bottom:${sz.bottom}px;left:${sz.left}px;right:${sz.right}px;border:2px solid rgba(34,197,94,0.85);box-shadow:inset 0 0 0 1px rgba(34,197,94,0.4);border-radius:4px;">
    <span style="position:absolute;top:-34px;left:0;background:rgba(34,197,94,0.9);color:#0b1117;font-weight:800;font-size:16px;padding:4px 10px;border-radius:6px;letter-spacing:1px;text-transform:uppercase;">✓ Safe Zone · ${platform}</span>
  </div>
</div>`;

  return { html };
}
